import script from "./NewsCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsCard.vue?vue&type=script&lang=ts&setup=true"

import "./NewsCard.vue?vue&type=style&index=0&id=34670eb9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34670eb9"]])

export default __exports__